// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.secondaryButton {
  background: white;
  color: gray;
  font-size: 12px;
  letter-spacing: 0.5px;
  border: 1px solid #dadada;
  border-radius: 10px;
  padding: 10px 20px;
  width: 150px;
  text-align: center;
}
.secondaryButton:hover {
  border: 1px solid #07a7e3;
  cursor: pointer;
}

.disabled {
  background: #dadada;
  color: gray;
  font-size: 12px;
  letter-spacing: 0.5px;
  border: 1px solid #dadada;
  border-radius: 10px;
  padding: 10px 20px;
  width: 150px;
  text-align: center;
}
.disabled:hover {
  background: white;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/StylesGuide/Buttons/SecondaryButton/SecondaryButton.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AACJ;AAAI;EACI,yBAAA;EACA,eAAA;AAER;;AAEA;EACI,mBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AACJ;AAAI;EACI,iBAAA;EACA,mBAAA;AAER","sourcesContent":[".secondaryButton {\n    background: white;\n    color: gray;\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    border: 1px solid #dadada;\n    border-radius: 10px;\n    padding: 10px 20px;\n    width: 150px;\n    text-align: center;\n    &:hover {\n        border: 1px solid #07a7e3;\n        cursor: pointer;\n    }\n}\n\n.disabled {\n    background: #dadada;\n    color: gray;\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    border: 1px solid #dadada;\n    border-radius: 10px;\n    padding: 10px 20px;\n    width: 150px;\n    text-align: center;\n    &:hover {\n        background: white;\n        cursor: not-allowed;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
